import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/global.css'
import axios from "axios";
import VueRouter from "vue-router";
import  router from './router';

//Vue.prototype.$httpUrl='http://47.129.119.196:8080'
Vue.prototype.$httpUrl='http://103.236.90.94:8090'
Vue.prototype.$axios=axios;
Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(VueRouter);


new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
